import appFulfillmentPlans from "../../views/appPlans/fulfillmentPlansView.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "fulfillment-plans";
  const params = ["page", "limit"];

  $stateProvider.state("fulfillmentplans", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appFulfillmentPlans,
      },
    },
    reloadOnSearch: false,
    data: { title: "FulfillmentPlans" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/fulfillmentPlans/fulfillmentPlans.urls.js